import React from "react";
import Chart from "react-apexcharts";

export default function ChartBarStackedRevers({ fullWidth, valueHight }) {
  let FullWidth = fullWidth ? fullWidth : null;
  const filterDataChart = (data) => {};
  const data = {
    options: {
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            total: {
              enabled: true,
              offsetX: 0,
              style: {
                fontSize: "13px",
                fontWeight: 900,
              },
            },
          },
        },
      },
      grid: {
        show: false,
      },
      stroke: {
        show: false,
      },

      chart: {
        stacked: true,

        stackType: FullWidth,
        background: "none",
        id: "basic-bar",
        events: {
          click: function (event, chartContext, config) {
            filterDataChart(config.dataPointIndex);
          },
        },
      },
      xaxis: {
        categories: ["categories 1", "categories 2", " categories 3"],
      },

      yaxis: {
        show: true,
      },
    },

    series: [
      {
        name: "Tank Picture",
        data: [1, 3, 8, 9],
      },
      {
        name: "Bucket Slope",
        data: [1, 3, 8, 9].map((k) => -k),
      },
    ],
  };

  return (
    <>
      <Chart
        options={data.options}
        series={data.series}
        type="bar"
        height={valueHight ? valueHight : 200}
        width="100%"
      />
    </>
  );
}
